import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  CustomTabView,
  InputNumeroInteiro,
  InputText,
  UploadFileBtn,
} from '../../../../components'
import { TabPanel } from 'primereact/tabview'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { urlTpLogo } from '../../../../services/api/routes/settings.routes'
import { Button } from 'primereact/button'
import InputCoordenada from '../../../../components/InputCoordenada/InputCoordenada'
import InputCnpjCpf from '../../../../components/InputCnpjCpf/InputCnpjCpf'
import useModalTp, { LOAD_MESSAGE, showVehicleBy } from './ModalTPHook'

const ModalTP = ({ data, dispatch, onModalSave, onModalClose, show, operationsCenters }) => {
  // Hooks

  const [globalFilter, setGlobalFilter] = useState('')
  const { state, localDispatch } = useModalTp()

  useEffect(() => {
    if (show) {
      localDispatch.onInit(data, operationsCenters)
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.LOADING_EDIT:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchUFs(state.tp.uf_id)
        break
      case LOAD_MESSAGE.LOADING_CITIES:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchCities(state.selectedUf.id, state.tp.city_id)
        break
      case LOAD_MESSAGE.LOADING_CNPJ_DATA:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchCnpjData(state.tp.cnpj)
        break
      case LOAD_MESSAGE.LOADING_CITY_COORDINATES:
        localDispatch.fetchCities(state.selectedUf.id, state.tp.city_id)
        localDispatch.fetchCoordinates(
          state.tp.number,
          state.tp.address,
          state.tp.district,
          state.selectedCity,
        )
        break
      case LOAD_MESSAGE.LOADING_COORDINATES:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchCoordinates(
          state.tp.number,
          state.tp.address,
          state.tp.district,
          state.cities.find(c => c.id === state.tp.city_id),
        )
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        onModalSave(state.tp)
        localDispatch.resetError()
        break
      case LOAD_MESSAGE.COPIED:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        localDispatch.resetError()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetError()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      width={700}
      header="Operador Logístico"
      isVisible={show}
      onClose={onModalClose}
      style={{ maxWidth: '95vw' }}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
    >
      <CustomTabView activeIndex={state.actived_index || 0} onTabChange={localDispatch.onTabChange}>
        <TabPanel header={'Principal'}>
          <form className="p-grid">
            <div className="p-col-12">
              <InputText
                label="Descrição :"
                marginTop={10}
                value={state.tp.name}
                onChange={value => localDispatch.onInputChange('name', value)}
              />
            </div>
            <div className="p-col-12">
              <CustomDropdown
                options={showVehicleBy}
                value={state.tp.show_vehicles_by ? state.tp.show_vehicles_by.value : ''}
                onChange={e => {
                  const selected = showVehicleBy.find(s => s.value === e)
                  localDispatch.onInputChange('show_vehicles_by', selected)
                }}
                label="Selecionar Veículos Por:"
              />
            </div>

            <div className="p-col-12">
              <CustomDropdown
                filter={true}
                optionLabel={'name'}
                options={operationsCenters.map(p => ({ id: p.id, name: p.name }))}
                value={state.tp.opCenterDefault}
                onChange={e => {
                  localDispatch.onInputChange('opCenterDefault', e)
                }}
                label="Central Padrão para Expedição:"
              />
            </div>

            <div className="p-col-4">
              <InputCnpjCpf
                label="CNPJ/CPF :*"
                marginTop={10}
                value={state.tp.cnpj || ''}
                onChange={({ value }) => localDispatch.onCnpjChange(value, state.tp.id)}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                optionLabel="name"
                options={state.ufs}
                value={state.selectedUf}
                label="Estado :*"
                filter={true}
                onChange={value => localDispatch.onEstadoChange(value)}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                disabled={state.selectedUf === 0}
                optionLabel="name"
                options={state.cities}
                value={state.selectedCity}
                label="Cidade :*"
                filter={true}
                onChange={value => localDispatch.onCityChange('city_id', value)}
              />
            </div>
            <div className="p-col-6">
              <InputText
                label="Endereço :*"
                marginTop={10}
                value={state.tp.address || ''}
                onChange={value => localDispatch.onInputChange('address', value.toUpperCase())}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label="Bairro :*"
                marginTop={10}
                value={state.tp.district || ''}
                onChange={value => localDispatch.onInputChange('district', value.toUpperCase())}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label="Número :*"
                marginTop={20}
                value={state.tp.number || ''}
                onChange={value => localDispatch.onInputChange('number', value.toUpperCase())}
              />
            </div>
            <div className="p-inputgroup p-col-8" style={{ alignItems: 'flex-end' }}>
              <InputCoordenada
                label={'Coordenadas :*'}
                onChange={value => localDispatch.onInputChange('latitude', value)}
                value={state.tp.latitude || ''}
              />
              <InputCoordenada
                onChange={value => localDispatch.onInputChange('longitude', value)}
                value={state.tp.longitude || ''}
              />
              <Button
                icon="pi pi-map-marker"
                label="Encontrar"
                style={{ backgroundColor: '#14B0BF', height: 30 }}
                onClick={e => {
                  e.preventDefault()
                  const { number, address, district } = state.tp
                  const city = state.selectedCity

                  if (!number || !address || !district || !city || !city.id) {
                    dispatch(
                      showMessageBox(
                        null,
                        'Preencha todos os campos necessários para poder gerar as coordenadas',
                      ),
                    )
                    return
                  }

                  localDispatch.onSearchCoordinatesClick(e, city.id)
                }}
              />
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                onChange={value => localDispatch.onInputChange('actived', value ? 1 : 0)}
                checked={state.tp.actived === 1}
              >
                Ativo
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                onChange={value =>
                  localDispatch.onInputChange('expedicao_gerar_picking_completo', value ? 1 : 0)
                }
                checked={state.tp.expedicao_gerar_picking_completo === 1}
              >
                Gerar Picking Completo para Conferencia da Expedição
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                onChange={value =>
                  localDispatch.onInputChange(
                    'entregas_picking_concluido_carregamento',
                    value ? 1 : 0,
                  )
                }
                checked={state.tp.entregas_picking_concluido_carregamento === 1}
              >
                Mostrar apenas entregas com Resumo Emitido no 3.4
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                onChange={value =>
                  localDispatch.onInputChange(
                    'bloquear_envio_rota_sem_pallet_carregado',
                    value ? 1 : 0,
                  )
                }
                checked={state.tp.bloquear_envio_rota_sem_pallet_carregado === 1}
              >
                Bloquear o Envio para a Rota (tela 3.7) de Entregas com Pallet não Carregado
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                onChange={value => localDispatch.onInputChange('mfa_habilitado', value ? 1 : 0)}
                checked={state.tp.mfa_habilitado === 1}
              >
                Habilitar Autenticação Multifator para usuários associados ao Operador Logístico
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                onChange={value =>
                  localDispatch.onInputChange('reentrega_exige_ocorrencia', value ? 1 : 0)
                }
                checked={state.tp.reentrega_exige_ocorrencia === 1}
              >
                Tornar obrigatória a associação de Ocorrência de Entrega para Reentregas
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.tp)}>Salvar</Btn>
            </div>
          </form>
        </TabPanel>

        <TabPanel header={'Assoc. Empresas'}>
          <div className="p-grid">
            <div className="p-col-4">
              <InputNumeroInteiro
                label="Limite Empresas Vínculadas :"
                marginTop={20}
                value={state.tp.companies_limit}
                onChange={value => localDispatch.onInputChange('companies_limit', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroInteiro
                label="Empresas Vínculadas:"
                marginTop={20}
                value={state.tp.companies_limit_enabled}
                onChange={() => {}}
                disabled
              />
            </div>
            <div className="p-col-4" style={{ marginTop: 35 }}>
              <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.tp)}>Salvar</Btn>
            </div>
            <div className="p-col-12">
              <DataTable
                dataKey="company_id"
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                value={state.tp.assoc_companies.sort((a, b) => {
                  if (a.active !== b.active) {
                    return b.active - a.active
                  }
                  return a.company_name.localeCompare(b.company_name)
                })}
                rows={5}
                paginator={true}
              >
                <Column field={'company_name'} header={'Empresa'} />
                <Column
                  header={'Ativo'}
                  body={item => (
                    <CustomCheckbox
                      disabled={state.updatingAssoc}
                      onChange={checked =>
                        localDispatch.onAssocTpEmpresaClick(item, {
                          active: checked,
                          obrigar_carregar: item.obrigar_carregar,
                          envio_picking_conferido: item.envio_picking_conferido,
                        })
                      }
                      checked={item.active === 1}
                    />
                  )}
                  style={tableCellCentered()}
                />
                <Column
                  header={'Obrigar Carregar'}
                  body={item => (
                    <CustomCheckbox
                      disabled={state.updatingAssoc}
                      onChange={checked =>
                        localDispatch.onAssocTpEmpresaClick(item, {
                          active: item.active,
                          obrigar_carregar: checked,
                          envio_picking_conferido: item.envio_picking_conferido,
                        })
                      }
                      checked={item.obrigar_carregar === 1}
                    />
                  )}
                  style={tableCellCentered()}
                />
                <Column
                  header={'Envio Picking Conferido'}
                  body={item => (
                    <CustomCheckbox
                      disabled={state.updatingAssoc}
                      onChange={checked =>
                        localDispatch.onAssocTpEmpresaClick(item, {
                          active: item.active,
                          obrigar_carregar: item.obrigar_carregar,
                          envio_picking_conferido: checked ? 1 : 0,
                        })
                      }
                      checked={item.envio_picking_conferido === 1}
                    />
                  )}
                  style={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </TabPanel>

        <TabPanel header={'Assoc. Emissores CTe'}>
          <div className="p-grid">
            <div className="p-col-12">
              <DataTable
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                value={state.tp.assoc_emissores}
                rows={5}
                paginator={true}
              >
                <Column field={'emissor_name'} header={'Emissor'} />
                <Column
                  header={'Ativo'}
                  body={item => (
                    <CustomCheckbox
                      onChange={checked =>
                        localDispatch.onAssocTpEmissorClick(item, checked, state.tp.id)
                      }
                      checked={item.active === 1}
                    />
                  )}
                  style={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </TabPanel>

        <TabPanel header={'Logo'}>
          <div className="p-grid">
            <div className="p-col-12" style={{ height: '50px' }}>
              <UploadFileBtn
                label="Anexar Logo"
                name="logo"
                url={urlTpLogo(state.tp.id)}
                onUploadCompleted={value => localDispatch.onUploadCompleted(value, state.tp.id)}
              />
            </div>
            <div className="p-col-12">
              {state.tp.logo_img ? (
                <img
                  src={`${state.tp.logo_img}`}
                  alt="Logo operador logistico"
                  style={{ maxWidth: 500 }}
                />
              ) : null}
            </div>
          </div>
        </TabPanel>

        <TabPanel header={'Permissões'}>
          <div className="p-grid">
            <div className="p-col-4">
              <InputNumeroInteiro
                label="Total Licenças TpDrive :"
                marginTop={20}
                value={state.tp.total_tpdrive_licenses}
                onChange={value => localDispatch.onInputChange('total_tpdrive_licenses', value)}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroInteiro
                label="Total Licenças TpDrive Usadas:"
                marginTop={20}
                value={state.tp.total_tpdrive_licenses_enabled}
                disabled
              />
            </div>
            <div className="p-col-4" style={{ marginTop: 35 }}>
              <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.tp)}>Salvar</Btn>
            </div>

            <div className="p-col-8">
              <InputText
                label="Token Acesso Robô XML :"
                marginTop={20}
                value={state.tp.token_robot || ''}
                onChange={value => localDispatch.onInputChange('token_robot', value)}
                disabled
              />
            </div>
            <div className="p-col-2" style={{ marginTop: 35 }}>
              <Btn onClick={() => localDispatch.onBotaoCopiarTokenClicked(state.tp.token_robot)}>
                Copiar
              </Btn>
            </div>
            <div className="p-col-2" style={{ marginTop: 35 }}>
              <Btn onClick={() => localDispatch.onBtnGerarTokenClicked(state.tp)}>Gerar</Btn>
            </div>
            <div className="p-col-5">
              <CustomDropdown
                label="Usuário Administrador"
                optionLabel="name"
                options={state.usersOfTp}
                value={state.selectedUserAdmin}
                filter
                onChange={localDispatch.onChangeUserAdmin}
              />
            </div>
            <div className="p-col-2" style={{ marginTop: 30 }}>
              <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.tp)}>Salvar</Btn>
            </div>

            <div className="p-col-12">
              <p
                style={{
                  color: '#14B0BF',
                  display: 'block',
                }}
              >
                Permissionamento de Módulos
              </p>
            </div>
            <div className="p-col-12">
              <DataTable
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                value={state.tp.permissions}
                rows={5}
                paginator={true}
              >
                <Column field={'id'} header={'Id'} style={tableCellCentered(80)} />
                <Column field={'name'} header={'Permissão'} />
                <Column
                  header={'Ativo'}
                  body={item => (
                    <CustomCheckbox
                      onChange={checked =>
                        localDispatch.onAssocTpPermissionClick(item, checked, state.tp.id)
                      }
                      checked={item.selected}
                    />
                  )}
                  style={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </TabPanel>

        <TabPanel header={'Integrações'}>
          <div className="p-grid">
            <div className="p-col-12">
              <p
                style={{
                  color: '#14B0BF',
                  display: 'block',
                }}
              >
                Grafos
              </p>
            </div>
            <div className="p-col-12" style={{ marginBottom: 10 }}>
              <CustomCheckbox
                checked={!!state.tp.grafos_ativo}
                onChange={localDispatch.onChangeGrafosAtivo}
              >
                Integração ativa
              </CustomCheckbox>
            </div>
            <div className="p-col-8">
              <InputText
                label="Token Integração Grafos :"
                marginTop={20}
                value={state.tp.token_grafos || ''}
                onChange={value => localDispatch.onInputChange('token_grafos', value)}
                disabled
              />
            </div>
            <div className="p-col-2" style={{ marginTop: 35 }}>
              <Btn onClick={() => localDispatch.onBotaoCopiarTokenClicked(state.tp.token_grafos)}>
                Copiar
              </Btn>
            </div>
            <div className="p-col-2" style={{ marginTop: 35 }}>
              <Btn onClick={() => localDispatch.onBtnGerarTokenGrafosClicked()}>Gerar</Btn>
            </div>
            <div className="p-col-5">
              <CustomDropdown
                label="Usuário Responsável — Integração Grafos"
                optionLabel="name"
                options={state.usersOfTp}
                value={state.selectedGrafosUser}
                filter
                onChange={localDispatch.onChangeGrafosUser}
              />
            </div>
            <div className="p-col-2" style={{ marginTop: 30 }}>
              <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.tp)}>Salvar</Btn>
            </div>
          </div>
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

export default connect()(ModalTP)
